import httpClient from "./index";

const END_POINT = "login";

const login = async (data) =>
  await httpClient.post(`${END_POINT}`, { ...data });

export { login };
